var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    "aria-label": "Herunterladen",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M2 16q-.824 0-1.412-.588A1.93 1.93 0 0 1 0 14v-3h2v3h12v-3h2v3q0 .825-.588 1.412A1.93 1.93 0 0 1 14 16zm6-4L3 7l1.4-1.45L7 8.15V0h2v8.15l2.6-2.6L13 7z",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;